<template>
    <div class="container">
        <noscript>
            <strong>��� ������ ����� ���������� �������� ��������� JavaScript.</strong>
        </noscript>
        <main role="main" class="pb-3">
            <router-view></router-view>
        </main>
    </div>
</template>